import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

interface AssetReportStore {
  userToken: string | null; // State value for user token (can be null initially)
  saveToken: (token: string) => void; // Function to save the token
}

export const useAssetReportStore = create<AssetReportStore>()(
  immer((set, get) => ({
    userToken: null, // Initial state value for userToken
    saveToken: (token: string) => {
      // token is a string
      set((state: AssetReportStore) => ({
        // state is of type AssetReportStore
        ...state,
        userToken: token, // Set userToken to the new token
      }));
    },
  }))
);
